The interval the remuneration amounts are calculated over.

Currently three interval codes are defined:

- `Hour` is used to express hourly rates.
- `Month` is used to express monthly salaries.
- `Year` is used to express annual salaries or commissions.
